// 用户管理相关页面组件
import EmptyRouterView from '../components/EmptyRouterView/index.vue'
import ClientUserList from '../views/user-management/client-user/index.vue'
import ClientUserDetail from '../views/user-management/client-user/detail.vue'
import CouponManagement from '../views/user-management/coupon-management/index.vue'
import FeedbackManagement from '../views/user-management/feedback-management/index.vue'

// 用户管理路由配置
export const userRoutes = {
  path: 'user-management',
  name: 'ClientUserManagement',
  component: EmptyRouterView,
  meta: {
    title: '用户管理',
    icon: 'el-icon-user-solid',
    hidden: false
  },
  children: [
    {
      path: 'client-user',
      name: 'ClientUserList',
      component: ClientUserList,
      meta: {
        title: '用户管理',
        icon: 'el-icon-user',
        hidden: false
      }
    },
    {
      path: 'client-user/detail',
      name: 'ClientUserDetail',
      component: ClientUserDetail,
      meta: {
        title: '用户详情',
        icon: 'el-icon-view',
        hidden: true
      }
    },
    {
      path: 'coupon-management',
      name: 'CouponManagement',
      component: CouponManagement,
      meta: {
        title: '优惠券管理',
        icon: 'el-icon-tickets',
        hidden: false
      }
    },
    {
      path: 'feedback-management',
      name: 'FeedbackManagement',
      component: FeedbackManagement,
      meta: {
        title: '意见反馈管理',
        icon: 'el-icon-chat-dot-round',
        hidden: false
      }
    }
  ]
}
